module.exports = __webpack_public_path__ + "static/media/tour.010dc2bd.svg";